import { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ProfileContext } from "../context/ProfileContext";

/**
 * Wrapper component that blocks chat access when user profile is incomplete.
 * All fields required: name, lastName, photoUrl, email, gender, birthdate, regNumber (Mongolia only).
 * Redirects to /profile if any required field is missing.
 */
export default function NameCollectionWrapper({ children }) {
  const {
    needsPhone, needsNameCollection, needsProfileCompletion,
    needsEmail, needsGender, needsBirthdate, needsRegNumber,
    profileReady, isTelegramUser, profile,
  } = useContext(ProfileContext);
  const navigate = useNavigate();
  const location = useLocation();

  const isProfileIncomplete = profileReady && (
    !profile ||
    (isTelegramUser && needsPhone) ||
    needsNameCollection ||
    needsProfileCompletion ||
    needsEmail ||
    needsGender ||
    needsBirthdate ||
    needsRegNumber
  );

  // Redirect to /profile if profile is incomplete
  useEffect(() => {
    if (isProfileIncomplete && location.pathname !== "/profile") {
      const currentPath = location.pathname + location.search;
      if (currentPath && currentPath !== "/" && currentPath !== "/profile") {
        localStorage.setItem("redirectPath", currentPath);
      }
      navigate("/profile", { replace: true });
    }
  }, [isProfileIncomplete, navigate, location.pathname, location.search]);

  // Show loading skeleton while profile is being checked
  if (!profileReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin border-4 border-t-4 rounded-full border-gray-300 border-t-blue-600 w-12 h-12"></div>
      </div>
    );
  }

  // Block rendering chat until profile is complete (redirect will happen via useEffect)
  if (isProfileIncomplete) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin border-4 border-t-4 rounded-full border-gray-300 border-t-blue-600 w-12 h-12"></div>
      </div>
    );
  }

  return children;
}
